var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4611 14.7763C21.49 15.5144 22.7504 15.9487 24.1118 15.9487V13.3197C23.8541 13.3198 23.5971 13.2928 23.3451 13.2392V15.3086C21.9839 15.3086 20.7236 14.8743 19.6944 14.1363V19.5012C19.6944 22.1851 17.5264 24.3606 14.8523 24.3606C13.8545 24.3606 12.9271 24.0579 12.1567 23.5387C13.036 24.4409 14.2622 25.0006 15.6188 25.0006C18.2931 25.0006 20.4612 22.8251 20.4612 20.1412V14.7763H20.4611ZM21.4068 12.124C20.881 11.5475 20.5358 10.8024 20.4611 9.97877V9.64062H19.7345C19.9174 10.6875 20.5412 11.5819 21.4068 12.124ZM13.8481 21.4792C13.5543 21.0926 13.3956 20.6197 13.3963 20.1335C13.3963 18.906 14.3879 17.9107 15.6113 17.9107C15.8393 17.9107 16.0659 17.9457 16.2832 18.0149V15.3272C16.0293 15.2922 15.773 15.2774 15.5168 15.2829V17.3749C15.2994 17.3057 15.0727 17.2705 14.8446 17.2707C13.6212 17.2707 12.6297 18.2659 12.6297 19.4935C12.6297 20.3616 13.1253 21.1131 13.8481 21.4792Z",
    fill: "#FF004F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6946 14.1362C20.7237 14.8743 21.984 15.3085 23.3453 15.3085V13.2392C22.5854 13.0767 21.9128 12.6783 21.407 12.124C20.5413 11.5818 19.9176 10.6875 19.7347 9.64062H17.8263V20.1411C17.822 21.3652 16.8321 22.3564 15.6113 22.3564C14.892 22.3564 14.2529 22.0123 13.8481 21.4792C13.1254 21.1131 12.6297 20.3615 12.6297 19.4936C12.6297 18.2661 13.6213 17.2708 14.8447 17.2708C15.0791 17.2708 15.305 17.3074 15.5169 17.3749V15.2829C12.8897 15.3374 10.7769 17.4917 10.7769 20.1411C10.7769 21.4637 11.303 22.6627 12.157 23.5387C12.9274 24.0579 13.8548 24.3606 14.8525 24.3606C17.5267 24.3606 19.6946 22.185 19.6946 19.5012V14.1362H19.6946Z",
    fill: "#1B2430"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3453 13.2385V12.679C22.6601 12.68 21.9884 12.4875 21.407 12.1233C21.9216 12.6887 22.5993 13.0786 23.3453 13.2385ZM19.7347 9.63999C19.7173 9.53994 19.7039 9.43923 19.6946 9.33814V9H17.0596V19.5005C17.0554 20.7245 16.0655 21.7157 14.8447 21.7157C14.4863 21.7157 14.1478 21.6303 13.8482 21.4786C14.2529 22.0116 14.892 22.3557 15.6113 22.3557C16.832 22.3557 17.8221 21.3646 17.8263 20.1405V9.63999H19.7347ZM15.517 15.2823V14.6866C15.2968 14.6564 15.0749 14.6412 14.8526 14.6413C12.1782 14.6413 10.0103 16.8169 10.0103 19.5005C10.0103 21.183 10.8623 22.6658 12.157 23.538C11.3031 22.662 10.7769 21.463 10.7769 20.1404C10.7769 17.491 12.8897 15.3367 15.517 15.2823Z",
    fill: "#00F2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c88aebf1.svg";
export { ForwardRef as ReactComponent };